import { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { useSubscription } from '../../hooks/useSubscription';

export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const { isOfflineDowngraded } = useSubscription();

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  // Show nothing if online and not downgraded
  if (!isOffline && !isOfflineDowngraded) return null;

  // Simple offline indicator (still has valid subscription)
  if (isOffline && !isOfflineDowngraded) {
    return (
      <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-center gap-2 text-amber-700 text-sm">
        <WifiOff className="w-4 h-4" />
        <span>You're offline — progress is saved and will sync when you reconnect.</span>
      </div>
    );
  }

  // Downgraded — subscription expired while offline
  return (
    <div className="bg-orange-50 border-b border-orange-200 px-4 py-2 flex items-center justify-center gap-2 text-orange-700 text-sm">
      <RefreshCw className="w-4 h-4" />
      <span>
        Some features are limited while offline. Connect to the internet to restore full access.
      </span>
    </div>
  );
}
